import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BanniereCookie = () => {
  const navigate = useNavigate();
  const [estVisible, setEstVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setEstVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setEstVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('cookieConsent', 'refused');
    localStorage.removeItem('theme');
    setEstVisible(false);
  };

  if (!estVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-fond-sombre/80 backdrop-blur-sm p-4">
      
      <div className="bg-gris-clair w-full max-w-xl rounded-xl shadow-2xl p-8 flex flex-col relative border-t-4 border-bleu-je">
        
        <h2 className="text-2xl font-bold text-bleu-sombre mb-3">À propos de vos cookies 🍪</h2>
        
        <p className="text-gris-sombre mb-4 leading-relaxed">
          Bonne nouvelle : ce site est respectueux de votre vie privée ! Nous
          n'utilisons <strong>aucun cookie publicitaire</strong>. Le seul traceur
          que nous utilisons sert uniquement à mémoriser votre préférence
          d'affichage (mode clair ou sombre) pour votre confort de navigation.
        </p>
        
        <button onClick={() => { navigate('/politique-de-confidentialite'); window.scrollTo(0, 0); }} className="text-bleu-je hover:text-bleu-sombre underline text-left text-sm mb-8 transition-colors self-start font-medium">
          Consulter notre politique de confidentialité
        </button>
        
        <div className="flex flex-col sm:flex-row gap-3 w-full justify-end">
          <button onClick={handleRefuse} className="bg-blanc-sombre hover:bg-bleu-gris hover:text-gris-clair text-gris-sombre transition-colors px-6 py-2.5 rounded-lg font-medium text-sm w-full sm:w-auto text-center">
            Refuser
          </button>
          <button onClick={handleAccept} className="bg-bleu-footer hover:bg-bleu-je text-gris-clair transition-colors px-6 py-2.5 rounded-lg font-medium text-sm shadow-md w-full sm:w-auto text-center">
            Accepter
          </button>
        </div>

      </div>
    </div>
  );
};

export default BanniereCookie;